import React from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import NewsWithImage from "../../molecules/NewsWithImage";

import { getSlug, getCollectionName } from "../../utils/utils";

import "./nineStories.m.css";

const NineStories = ({ collection, sections, domainSlug }) => {
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const stories = collection.items.filter((item) => item.type === "story");
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const firstStory = stories.length > 0 ? stories[0] : null;

  return (
    <div styleName="base" className="nine-stories">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionSlug={collectionSlug} collectionName={collectionName} />
      )}
      <div className="nine-stories">
        {stories.length > 1 && <Organism1 stories={stories.slice(1, 4)} className="left-storycards" />}
        {firstStory && <NewsWithImage story={firstStory.story} cssStyleName="semiBigSize" showExcerpt={true} />}
        {stories.length > 4 && <Organism1 stories={stories.slice(4, 7)} className="right-storycards" />}
      </div>
    </div>
  );
};

NineStories.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
};

NineStories.storyLimit = 7;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(NineStories);
